const MAX_STRING = 500;
const SENSITIVE_QUERY = /token|key|secret|password|auth|session|cookie|bearer/i;
const JWT_RE = /eyJ[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/g;
const SECRET_KEY_GROUP = '(?:password|secret|token|access[_-]?token|refresh[_-]?token|bearer|api[_-]?key|x-api-key|session|set-cookie|authorization|cookie|encryption_key|csrf)';
const JSON_SECRET_RE = new RegExp(`("${SECRET_KEY_GROUP}"\\s*:\\s*)"[^"]*"`, 'gi');
const KV_SECRET_RE = new RegExp(`(\\b${SECRET_KEY_GROUP}\\b\\s*[=:]\\s*)("?)[^\\s"',&]+`, 'gi');
const HEADER_BEARER_RE = /\bbearer\s+[A-Za-z0-9._\-+/=]+/gi;

const SENSITIVE_KEY_RE = /^(password|secret|token|access[_-]?token|refresh[_-]?token|bearer|api[_-]?key|x-api-key|session|set-cookie|authorization|cookie|encryption_key|csrf)$/i;

export function redactString(input) {
  if (typeof input !== 'string') return input;
  let s = input.replace(JWT_RE, '<jwt>');
  s = s.replace(JSON_SECRET_RE, '$1"<redacted>"');
  s = s.replace(HEADER_BEARER_RE, 'bearer <redacted>');
  s = s.replace(KV_SECRET_RE, '$1$2<redacted>');
  if (s.length > MAX_STRING) s = s.slice(0, MAX_STRING) + '...[truncated]';
  return s;
}

export function redactUrl(url) {
  if (typeof url !== 'string') return url;
  try {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.forEach((value, key) => {
      if (SENSITIVE_QUERY.test(key)) parsed.searchParams.set(key, '<redacted>');
    });
    return redactString(parsed.toString());
  } catch {
    return redactString(url);
  }
}

function safeStringify(value, seen = new WeakSet()) {
  if (value == null) return String(value);
  const t = typeof value;
  if (t === 'string') return redactString(value);
  if (t === 'number' || t === 'boolean' || t === 'bigint') return String(value);
  if (t === 'function') return '<fn>';
  if (t === 'symbol') return value.toString();
  if (value instanceof Error) {
    return redactString(`${value.name}: ${value.message}`);
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value, function replacer(k, v) {
        if (k && SENSITIVE_KEY_RE.test(k)) return '<redacted>';
        if (typeof v === 'string') return redactString(v);
        if (v && typeof v === 'object') {
          if (seen.has(v)) return '<circular>';
          seen.add(v);
        }
        return v;
      }).slice(0, MAX_STRING);
    } catch {
      return '<unserialisable>';
    }
  }
  return redactString(String(value));
}

export function redactConsoleArgs(args) {
  return args.map((a) => safeStringify(a));
}
